import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const ModalInfoContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors.bgOverlay};
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-in-out;
  opacity: ${props => (props.open ? '1' : '0')};
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  padding: 10px; /* Para que en pantallas pequeñas no toque los bordes */
`;

export const ModalInfoContent = styled.div`
  width: 90%;
  max-width: 650px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 90vh;
  overflow-y: auto;

  @media (max-width: 480px) {
    padding: 15px;
    border-radius: 12px;
  }
`;

export const ModalInfoHead = styled.div`
  display: flex;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;

export const ModalInfoBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 10px;

  img {
    max-width: 100%;
    height: auto;
    max-height: 25vh;
    object-fit: contain;
    border-radius: 8px;

    @media (max-width: 480px) {
      max-height: 200px;
    }
  }
`;

export const ModalInfoBodyLabel = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: ${colors.black};
  text-align: center;
  margin-bottom: 5px;

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const ModalInfoBodyDescription = styled.p`
  margin-top: 15px;
  max-width: 90%;
  font-size: 16px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ModalInfoFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 10px;
  width: 100%;
  align-items: center;

  @media (max-width: 480px) {
    margin-top: 15px;
  }
`;

export const ModalInfoFooterButton = styled.button`
  width: 90%;
  max-width: 280px;
  height: 40px;
  border-radius: 48px;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  transition: 0.2s;

  &:first-child {
    background: ${colors.bgPrimary};
    color: ${colors.white};
    border: 1px solid ${colors.bgPrimaryLight};

    &:hover {
      background: ${colors.bgPrimaryHover};
      border-color: ${colors.bgPrimaryLight};
    }
  }

  &:last-child {
    background: ${colors.white};
    border: 1px solid ${colors.textSecondary};
    color: ${colors.textPrimary};

    &:hover {
      box-shadow: 0px 5px 15px ${colors.shadowHover};
    }
  }
`;
